import { useEffect, useState } from "react";
import { CONFIG } from "@/lib/config";

const STEPS = ["INITIALIZING VERA", "ASSET LAYER", "CAPITAL LAYER", "SETTLEMENT LAYER", "VERA READY"];
const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const TIMINGS = REDUCED ? [0, 120, 240, 360, 480] : [0, 600, 1200, 1800, 2250];
const EXIT = REDUCED ? 700 : 2650;
const GONE = REDUCED ? 1100 : 3250;

export default function Loader() {
    const [step, setStep] = useState(0);
    const [fade, setFade] = useState(false);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        const timers = TIMINGS.map((t, i) => setTimeout(() => setStep(i), t));
        const t1 = setTimeout(() => setFade(true), EXIT);
        const t2 = setTimeout(() => setHidden(true), GONE);
        return () => {
            timers.forEach(clearTimeout);
            clearTimeout(t1);
            clearTimeout(t2);
        };
    }, []);

    if (hidden) return null;

    return (
        <div
            data-testid="vera-loader"
            aria-label="VERA loading"
            className={`fixed inset-0 z-[120] bg-vera-bg flex flex-col items-center justify-center transition-opacity duration-500 ${fade ? "opacity-0 pointer-events-none" : "opacity-100"}`}
        >
            <div className="relative mb-10">
                <div className="absolute -inset-6 rounded-full border border-vera-blue/20 animate-spin-slow" style={{ borderTopColor: "rgba(22,135,255,0.7)", borderStyle: "dashed" }} />
                <img src={CONFIG.LOGO} alt="VERA logo" className="w-24 h-24 object-contain mask-fade-circle" />
            </div>
            <div className="w-56 h-px bg-white/10 mb-8 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-vera-blue to-vera-gold2 transition-all duration-500" style={{ width: `${((step + 1) / STEPS.length) * 100}%` }} />
            </div>
            <ul className="space-y-1.5 text-center">
                {STEPS.map((s, i) => (
                    <li
                        key={s}
                        className={`font-mono text-[10px] tracking-[0.3em] transition-colors duration-300 ${i === step ? "text-vera-gold2" : i < step ? "text-vera-mut/60" : "text-white/15"}`}
                    >
                        {i < step ? "· " : i === step ? "▸ " : "  "}
                        {s}
                    </li>
                ))}
            </ul>
        </div>
    );
}
